module.exports = __webpack_public_path__ + "static/slide-3-0e15be8282ce36c213e5ec1c40553103.png";